import React, { useEffect, useState } from 'react'
import queryString from "utils/queryString";
import { getMissions } from 'services/mission.routes';
import { toast } from 'react-toastify';
import Loading from 'components/Loading';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import InfiniteScroll from 'react-infinite-scroll-component';
import MissionTable from './MissionTable';

export default function Mission() {
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [missions, setMissions] = useState([]);

    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
            with_category: 1,
            with_badge: 1
        }
        getMissions(queryString(query), false, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setMissions((prev) => ([...prev, ...data.data]));
                } else {
                    setMissions(data.data);
                }
                setLoading(false);
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                setHasMore(data.meta.next_cursor !== null);
            }
        })
    }, [page]);


    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={missions.length} next={fetchMoreData} hasMore={hasMore}>
                <MissionTable data={missions} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}
